/**
 * A Premium Set order is packages; every other order is inventory lines. The backend does not check
 * which it was sent (`validateAndGenerateOrder` takes the package path whenever `packages` is
 * non-empty and the items path otherwise), so the hub is the guard.
 *
 * Set orders still post `items`, but only the package's chosen dishes: `processPackagesOrder` reads
 * them from `cart.items`. Those lines carry no `product` object (see utils/cartItems.ts); an
 * inventory line always does.
 */

type AnyRecord = Record<string, any>

export const isSetOrder = (type: unknown, packageTypeId: unknown) =>
	type === "Daily" && Number(packageTypeId) === 1

export const inventoryLines = (order: AnyRecord | null | undefined) =>
	(Array.isArray(order?.items) ? order!.items : []).filter((item: AnyRecord) => !!item?.product)

export const packageLines = (order: AnyRecord | null | undefined) =>
	Array.isArray(order?.packages) ? order!.packages : []

/** Lines a switch to `toSet` would have to remove. */
export const linesRemovedBySwitch = (order: AnyRecord | null | undefined, toSet: boolean) =>
	toSet ? inventoryLines(order).length : packageLines(order).length

/** Why this cart can't be posted as its order type, or "" when it can. */
export function cartModeConflict(order: AnyRecord | null | undefined): string {
	if (isSetOrder(order?.type, order?.package_type_id)) {
		return inventoryLines(order).length
			? "A Premium Set order can only contain packages. Remove the other products to continue."
			: ""
	}
	return packageLines(order).length
		? "Packages can only be ordered on a Premium Set order. Remove the package to continue."
		: ""
}
